import { Avatar ,AvatarBadge} from "@chakra-ui/avatar";
import { Divider, IconButton } from "@chakra-ui/react";
import { Tooltip } from "@chakra-ui/tooltip";
import ScrollableFeed from "react-scrollable-feed";
import {
  isLastMessage,
  isSameSender,
  isSameSenderMargin,
  isSameUser,
} from "../config/ChatLogistics";
import { useEffect, useState } from "react";
import { getSender, getSenderFull } from "../config/ChatLogistics";

import { ChatState } from "../context/chatProvider";
import { m, useSpring } from "framer-motion";
import { LockIcon, UnlockIcon } from "@chakra-ui/icons";

var CryptoJS = require("crypto-js");

const ScrollableChat = ({ messages },glbEncrypt) => {
  const { selectedChat, setSelectedChat, user,notification, setNotification, globalEnc , setGlobalEnc } =
  ChatState();
  const [ encText, setEncText ] = useState()
  const [ decMsg, setDecMsg] = useState()
  const [ feed_ms, setFeed_ms] = useState()
 var key = `${selectedChat?._id}`;

  const decrypt = (msg,key) => {
    let dec 
    var bytes = CryptoJS.AES.decrypt(msg, key);
    dec = bytes.toString(CryptoJS.enc.Utf8)
    console.log('[ScrollableChat] decrypted msg :',dec)
     return dec
}

  const feed_msgs = messages?.map((m, i) => {
    let  m_obj = m
    if(m.isEncrypted){
      let dec_m_cont = decrypt(m?.content,key)
      m_obj = {
        ...m_obj,
        content: dec_m_cont
      } 
      console.log(`Changed feed _ms dec_m map${i}: `, m_obj)
      return m_obj
    }else{return m_obj}
  })

// console.log('[Pre-return] feed_msgs: ',feed_msgs)
  return (
    <ScrollableFeed>
      {feed_msgs &&
        feed_msgs.map((m, i) => (
          <div style={{ display: "flex" }} key={m?._id}
            onPointerDown={(e)=>decrypt(m?.content,m?.chat?._id)}
          >
            {(isSameSender(feed_msgs, m, i, user._id) ||
              isLastMessage(feed_msgs, i, user._id)) && (
              <Tooltip label={m?.sender?.preferredName} placement="bottom-start" hasArrow>
                <Avatar 
                  name={m?.sender?.preferredName}
                  mt="7px"
                  mr={1}
                  size="sm"
                  cursor="pointer"
                  // name={m.sender.preferredName}
                  src={m?.sender?.pic}
                  // border={'2px solid'}
                  backgroundColor={'#fff'}
                  border={m?.sender?.isOnline?'2px solid limegreen':'2px solid orange'}

                >
              <AvatarBadge 
                      h={'15px'}
                      w={'15px'}
                      border={'2px solid white'}
                      zIndex={1000}
                      borderRadius={'100%'}
                      backgroundColor={m.sender.isOnline?'limegreen':'orange'}
                      />
                </Avatar>
              </Tooltip>
            )}
               
            <div
              style={{
                color: "#fff",
                backgroundColor: `${
                  m.sender._id === user._id ? "rgba(190, 227, 248, 0.3)" : "rgba(185, 245, 208, 0.3)"
                }`,
                marginLeft: isSameSenderMargin(feed_msgs, m, i, user._id),
                marginTop: isSameUser(feed_msgs, m, i, user._id) ? 3 : 10,
                borderRadius: "0px 10px 0px 10px",
                padding: "5px 15px",
                maxWidth: "75%",
                backdropFilter: "blur(2px)",
                boxShadow: "inset 0px 0px 5px 2px rgba(0,0,0, 0.5),0px 0px 5px 0px rgba(0,0,0, 0.7)"
              }}
            >
              <div>
              {/* {`${decrypt(m.content)}`} */}
                {(!globalEnc )&&(
                  <>
                  {m.content}
                  </>
                )}
                {(globalEnc )&&(
                  <>
                  {messages[i].content}
                  </>
                )}
              </div>
             
              {/* {m?.isEncrypted ? `${decrypt( m.content ,m.chat._id)}`: m.content} */}
           <IconButton
            size={'0'}
            boxSize={'0'}
            float={'right'}
            m={3}
            icon={m.isEncrytpted?<LockIcon color='green'/>:<UnlockIcon color='red'/>}
            ></IconButton>
            </div>
            
            {(isLastMessage(feed_msgs, i) && (m.sender._id === user._id ) )
               && (
              <Tooltip label={'You'} placement="bottom-start" hasArrow>
                <Avatar 
                  name={m.sender.preferredName}
                  mt="7px"
                  mr={1}
                  ml={1}
                  size="sm"
                  cursor="pointer"
                  // name={m.sender.preferredName}
                  src={m.sender.pic}
                  // border={'2px solid'}
                  backgroundColor={'#fff'}
                  border={m.sender.isOnline?'2px solid limegreen':'2px solid orange'}
                >
              <AvatarBadge 
                      h={'15px'}
                      w={'15px'}
                      border={'2px solid white'}
                      zIndex={1000}
                      borderRadius={'100%'}
                      backgroundColor={m.sender.isOnline?'limegreen':'orange'}
                      />

                </Avatar>
              </Tooltip>
            )}
          </div>
        ))}
    </ScrollableFeed>
  );
};

export default ScrollableChat;